import * as Types from '../../../../graphql';

import { gql } from '@apollo/client';
import { CreateAccountTrialAccountFieldsFragmentDoc, CreateAccountTrialContactFieldsFragmentDoc } from '../../Plans/Trials/__gql/CreateAccountTrialFragments.gql.gen';
import * as Apollo from '@apollo/client';

/*
* This was automatically generated on by @graphql-codegen.
* DO NOT MANUALLY EDIT !!!
* Please refer to https://github.com/wistia/wistia/blob/main/frontend/graphql/README.md for more information.
* Last Updated: Fri Nov 14 2025 20:27:32 GMT+0000 (Coordinated Universal Time)
*/

const defaultOptions = {} as const;
export type StartTrialButtonAccountFragment = { __typename?: 'Account', id: string, formattedOwnerEmails: string, canStartTrials: boolean, plan?: { __typename?: 'Plan', id: string, tiered: boolean, tier?: Types.PlanTierEnum | null | undefined } | null | undefined, activeTrial?: { __typename?: 'Trial', id: string, plan: { __typename?: 'Plan', id: string, sku?: string | null | undefined, tier?: Types.PlanTierEnum | null | undefined } } | null | undefined, recentlyCompletedTrials?: Array<{ __typename?: 'Trial', id: string, plan: { __typename?: 'Plan', id: string, sku?: string | null | undefined, tier?: Types.PlanTierEnum | null | undefined } }> | null | undefined };

export type StartTrialButtonContactFragment = { __typename?: 'Contact', id: string, isGhosting: boolean, isOwner: boolean };

export type StartTrialButtonCreateAccountTrialMutationVariables = Types.Exact<{
  input: Types.CreateAccountTrialInput;
}>;


export type StartTrialButtonCreateAccountTrialMutation = { __typename?: 'Mutation', createAccountTrial?: { __typename?: 'CreateAccountTrialPayload', currentAccount: { __typename?: 'Account', id: string, atChannelLimit: boolean, canCreateChannels: boolean, canCreateLiveStreamEvents: boolean, canStartTrials: boolean, channelsLimit?: number | null | undefined, formattedOwnerEmails: string, usersLimit?: number | null | undefined, liveEventAttendeesLimit?: number | null | undefined, liveEventAttendeeOveragePrice?: number | null | undefined, liveEventMinutesLimit?: number | null | undefined, liveEventMinuteOveragePrice?: number | null | undefined, experimentEnrollments: Array<{ __typename?: 'ExperimentEnrollment', id: string, key: string, group?: string | null | undefined, isLive: boolean }>, activeTrial?: { __typename?: 'Trial', id: string, active: boolean, endsAt: string, plan: { __typename?: 'Plan', id: string, sku?: string | null | undefined, name: string } } | null | undefined }, currentContact: { __typename?: 'Contact', id: string, isOwner: boolean, email: string, permissions: { __typename?: 'Permissions', canAccessABTests: boolean, canAccessAnalyticsAudience: boolean, canAccessAnalyticsDataExport: boolean, canAccessAnalyticsEmbedMediaStatsV2Details: boolean, canAccessAnalyticsHeatmaps: boolean, canAccessAnalyticsViewStreams: boolean, canAccessAnalyticsCompareMedia: boolean, canAccessChannels: boolean, canAccessChannelsLimited: boolean, canAccessCustomizeCtaHtml: boolean, canAccessCustomizeCtaImage: boolean, canAccessCustomizeCtaText: boolean, canAccessCustomizePassword: boolean, canAccessCustomizeTurnstile: boolean, canAccessCustomizeLocalizations: boolean, canAccessOrderAudioDescriptions: boolean, canAccessLiveStream: boolean, canAccessLiveStreamCustomizeBranding: boolean } } } | null | undefined };

export const StartTrialButtonAccountFragmentDoc = gql`
    fragment StartTrialButtonAccount on Account {
  id
  formattedOwnerEmails
  canStartTrials
  plan {
    id
    tiered
    tier
  }
  activeTrial {
    id
    plan {
      id
      sku
      tier
    }
  }
  recentlyCompletedTrials {
    id
    plan {
      id
      sku
      tier
    }
  }
}
    `;
export const StartTrialButtonContactFragmentDoc = gql`
    fragment StartTrialButtonContact on Contact {
  id
  isGhosting
  isOwner
}
    `;
export const StartTrialButtonCreateAccountTrialDocument = gql`
    mutation StartTrialButtonCreateAccountTrial($input: CreateAccountTrialInput!) {
  createAccountTrial(input: $input) {
    currentAccount {
      id
      ...createAccountTrialAccountFields
    }
    currentContact {
      id
      ...createAccountTrialContactFields
    }
  }
}
    ${CreateAccountTrialAccountFieldsFragmentDoc}
${CreateAccountTrialContactFieldsFragmentDoc}`;
export type StartTrialButtonCreateAccountTrialMutationFn = Apollo.MutationFunction<StartTrialButtonCreateAccountTrialMutation, StartTrialButtonCreateAccountTrialMutationVariables>;

/**
 * __useStartTrialButtonCreateAccountTrialMutation__
 *
 * To run a mutation, you first call `useStartTrialButtonCreateAccountTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTrialButtonCreateAccountTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTrialButtonCreateAccountTrialMutation, { data, loading, error }] = useStartTrialButtonCreateAccountTrialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartTrialButtonCreateAccountTrialMutation(baseOptions?: Apollo.MutationHookOptions<StartTrialButtonCreateAccountTrialMutation, StartTrialButtonCreateAccountTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartTrialButtonCreateAccountTrialMutation, StartTrialButtonCreateAccountTrialMutationVariables>(StartTrialButtonCreateAccountTrialDocument, options);
      }
export type StartTrialButtonCreateAccountTrialMutationHookResult = ReturnType<typeof useStartTrialButtonCreateAccountTrialMutation>;
export type StartTrialButtonCreateAccountTrialMutationResult = Apollo.MutationResult<StartTrialButtonCreateAccountTrialMutation>;
export type StartTrialButtonCreateAccountTrialMutationOptions = Apollo.BaseMutationOptions<StartTrialButtonCreateAccountTrialMutation, StartTrialButtonCreateAccountTrialMutationVariables>;